// 图层透明度控制
import { getLayerExist } from './layerStatusControl'

/**
 * 基于Layer信息 设置 Layer的透明度
 * @param {JSON} params 图层参数信息
 * @param {Number} alpha 透明度信息 0.0 为透明 1.0 为不透明
 */
function setLayerAlpha (params, alpha) {
  // todo 参数校验
  const layerInfoAll = getLayerExist(params)
  // let addInfo = {
  //   info: params,
  //   layer: imageProvider,
  //   market: imageMarket
  // }
  const layerMarket = layerInfoAll.market
  if (layerMarket) {
    layerMarket.alpha = alpha
    return true
  }
  return false
}

export { setLayerAlpha }
